import React from 'react';

const translations = {
  id: { home: 'Beranda', search: 'Cari video...', latest: 'Video Terbaru', trending: 'Trending', comments: 'Komentar', like: 'Suka', dislike: 'Tidak Suka', share: 'Bagikan', save: 'Simpan', report: 'Laporkan', back: 'Kembali', novideos: 'Tidak ada video', addcomment: 'Tulis komentar...', post: 'Kirim', views: 'Ditonton', embed: 'Embed' },
  en: { home: 'Home', search: 'Search videos...', latest: 'Latest Videos', trending: 'Trending', comments: 'Comments', like: 'Like', dislike: 'Dislike', share: 'Share', save: 'Save', report: 'Report', back: 'Back to videos', novideos: 'No videos found', addcomment: 'Add a comment...', post: 'Post', views: 'Views', embed: 'Embed' }
};

export const LangContext = React.createContext({ lang: 'id', t: translations.id, setLang: () => {} });

export const useLang = () => React.useContext(LangContext);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = React.useState(() => localStorage.getItem('lang') || 'id');

  React.useEffect(() => { localStorage.setItem('lang', lang); }, [lang]);

  const t = translations[lang] || translations.id;

  return <LangContext.Provider value={{ lang, t, setLang }}>{children}</LangContext.Provider>;
};

const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <button onClick={() => setLang(lang === 'id' ? 'en' : 'id')} className="lang-toggle" title={lang === 'id' ? 'English' : 'Bahasa Indonesia'}>
      {lang === 'id' ? '🇬🇧' : '🇮🇩'}
    </button>
  );
};

export default LangToggle;
